export default __webpack_public_path__ + "static/media/vBusd.3825d1d1.svg";